<template>
  <div class="membershipWrap">
    <div class="cancel" @click="cancel">x</div>
    <!-- 会员类型tab切换 -->
    <ul class="membershipTab">
      <li class="membershipType" v-for="(item, index) in membershipType" :key="index"
        :class="{ 'goldColor': item.type === 2, 'damondColor': item.type === 3, 'height': onceNum === item.type }"
        @click="tabChange(item.type)">
        <img :src="item.url" alt="">
        <span>{{ item.name }}</span>
      </li>
    </ul>
    <!-- 切换黄金会员box -->
    <div class="membershipCont goldmembershipCont" :class="onceNum === 2 ? 'membershipActBgCol_2' : ''"
      v-if="onceNum === 2">
      <div class="leftCont">
        <h1>VIP特权</h1>
        <ul class="privClassif" v-for="item in goldvipPrivil" :key="item.name">
          <li>
            <img :src="item.url" alt="">
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <div class="rightCont">
        <div class="topSection">
          <ul>
            <li v-for="item in  golddateList" :key="item.types" :class="{ 'actBgCol': dataNum === item.types }"
              @click="goldvipBoxChange(item.typeMember, item.types, item.price)">
              <!-- <div v-if="item.types === 1" class="rightTop" style="color: #FF0808;">新春特惠</div> -->
              <div v-if="item.types === 2" class="rightTop">立减20</div>
              <div v-else-if="item.types === 3" class="rightTop">立减51</div>

              <div class="vipDate">{{ item.date }}年VIP</div>

              <div v-if="item.types === 1" class="vipPrice">￥{{ item.price }}
              </div>
              <div v-else-if="item.types === 2" class="vipPrice">￥{{ item.price }}<span class="smallTxt">
                  ¥398
                </span></div>
              <div v-else-if="item.types === 3" class="vipPrice">￥{{ item.price }}<span class="smallTxt">
                  ¥597
                </span></div>

              <div v-if="item.types === 1" class="txt">包含{{ item.points }}积分</div>
              <div v-else-if="item.types === 2" class="txt">包含{{ item.points }}积分+赠送{{ item.pointsLot }}积分</div>
              <div v-else-if="item.types === 3" class="txt">包含{{ item.points }}积分+赠送{{ item.pointsLot }}积分</div>
              <div class="gouxuan"></div>
            </li>
          </ul>
        </div>
        <div class="bottSection">
          <div class="left">
            <h1 class="methodTxt">付款方式</h1>
            <ul class="payMethods">
              <li @click="item.type !== 3 && payToggle(item.type)" v-for="item in payMethod" :key="item.type"
                :class="{ 'actBgColor': payNum === item.type }">
                <img v-if="item.type === 1" :src="item.url" alt="">
                <img v-else-if="item.type === 2" :src="item.url" alt="">
                <img class="payPalImg" v-else-if="item.type === 3" :src="item.url" alt="">
                <div v-if="item.type === 3" class="rightTop">暂未开通</div>
                <span v-if="item.name">{{ item.name }}</span>
                <div v-if="item.type !== 3 && payNum === item.type" class="gouxuan"></div>
              </li>
            </ul>
            <div class="bottomText">
              <p class="txt">*开通高等级会员优先生效，低等级会员顺延</p>
            </div>
            <div v-clickoutside="handleClickontactUs" class="code" v-if="ishidden">
              <img src="@/assets/link.png" alt="">
              <p>
                扫码联系客服
              </p>
            </div>
            <div class="contactCust">充值遇到问题？<a @click="contactCustFn">联系客服</a></div>
          </div>
          <div class="right">
            <div v-if="payNum === 1" class="qrcodePic" style="margin-top: 30px; padding-left: 25px" id="wxQrcodeImg"
              ref="wxQrcodeImg">
            </div>
            <div v-else-if="payNum === 2" class="qrcodePic"
              style="margin-top: 30px; padding-left: 25px; margin-bottom: 0px; width: 150px; overflow: hidden;"
              id="zxbIframe" ref="zxbIframe">
              <iframe frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" width="120" height="120"
                style="overflow: hidden;" id="zfbQrcodeImg" ref="zfbQrcodeImg" name="zxbIframe">
              </iframe>
            </div>
            <div class="price">
              <span class="totalPrice">¥{{ goldVipPrice }}</span>
              <span class="qrcodePay">( 扫码支付 )</span>
            </div>
            <div class="delayTime">若二维码过期失效，请刷新页面重新进入支付！</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 切换白银会员box -->
    <div class="membershipCont silvermembershipCont" :class="onceNum === 1 ? 'membershipActBgCol_1' : ''"
      v-else-if="onceNum === 1">
      <div class="leftCont">
        <h1>VIP特权</h1>
        <ul class="privClassif" v-for="item in silvervipPrivil" :key="item.name">
          <li>
            <img :src="item.url" alt="">
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <div class="rightCont">
        <div class="topSection">
          <ul>
            <li v-for="item in  silverdateList" :key="item.types" :class="{ 'actBgCol': dataNum === item.types }"
              @click="silvervipBoxChange(item.typeMember, item.types, item.price)">
              <div v-if="item.types === 1" class="vipDate"><span :class="{ 'actSub': silverDate < 1 || silverDate === 1 }"
                  @click="sub(item)"> - </span>{{ silverDate }}个月<span @click="add(item)" class="add"> + </span></div>

              <div v-if="item.types !== 1" class="vipDate">{{ item.date }}个月</div>

              <div v-if="item.types === 1" class="vipPrice">￥{{ silverPrice }}</div>

              <div v-else-if="item.types === 2" class="vipPrice">￥{{ item.price }}</div>
              <div v-else-if="item.types === 3" class="vipPrice">￥{{ item.price }}</div>

              <div v-if="item.types === 1" class="txt">包含{{ silverPoints }}积分</div>
              <div v-else-if="item.types === 2" class="txt">包含{{ item.points }}积分+赠送{{ item.pointsLot }}积分</div>
              <div v-else-if="item.types === 3" class="txt">包含{{ item.points }}积分+赠送{{ item.pointsLot }}积分</div>
              <div class="gouxuan"></div>
            </li>
          </ul>
        </div>
        <div class="bottSection">
          <div class="left">
            <h1 class="methodTxt">付款方式</h1>
            <ul class="payMethods">
              <li @click="item.type !== 3 && payToggle(item.type)" v-for="item in payMethod" :key="item.types"
                :class="{ 'actBgColor': payNum === item.type }">
                <img v-if="item.type === 1" :src="item.url" alt="">
                <img v-else-if="item.type === 2" :src="item.url" alt="">
                <img class="payPalImg" v-else-if="item.type === 3" :src="item.url" alt="">
                <div v-if="item.type === 3" class="rightTop">暂未开通</div>
                <span v-if="item.name">{{ item.name }}</span>
                <div v-if="item.types !== 3 && payNum === item.type" class="gouxuan"></div>
              </li>
            </ul>
            <div class="bottomText">
              <p class="txt">*开通高等级会员优先生效，低等级会员顺延</p>
            </div>
            <div v-clickoutside="handleClickontactUs" class="code" v-if="ishidden">
              <img src="@/assets/link.png" alt="">
              <p>
                扫码联系客服
              </p>
            </div>
            <div class="contactCust">充值遇到问题？<a @click="contactCustFn">联系客服</a></div>
          </div>
          <div class="right">
            <div v-if="payNum === 1" style="margin-top: 30px; padding-left: 25px" class="qrcodePic" id="wxQrcodeImg"
              ref="wxQrcodeImg"></div>
            <div v-else-if="payNum === 2" class="qrcodePic"
              style="margin-top: 30px; padding-left: 25px; margin-bottom: 0px; width: 150px; overflow: hidden;"
              id="zxbIframe" ref="zxbIframe">
              <iframe frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" width="120" height="120"
                style="overflow: hidden;" id="zfbQrcodeImg" ref="zfbQrcodeImg" name="zxbIframe">
              </iframe>
            </div>
            <div class="price">
              <span v-if="dataNum === 1" class="totalPrice">¥{{ silverPrice }}</span>
              <span v-else-if="dataNum !== 1" class="totalPrice">¥{{ sliverVipPrice }}</span>
              <span class="qrcodePay">( 扫码支付 )</span>
            </div>
            <div class="delayTime">若二维码过期失效，请刷新页面重新进入支付！</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 切换钻石会员box -->
    <div class="membershipCont diamondmembershipCont" :class="onceNum === 3 ? 'membershipActBgCol_3' : ''"
      v-else-if="onceNum === 3">
      <div class="leftCont">
        <h1>VIP特权</h1>
        <ul class="privClassif" v-for="item in diamondvipPrivil" :key="item.name">
          <li>
            <img :src="item.url" alt="">
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <div class="rightCont">
        <div class="topSection">
          <ul>
            <li v-for="item in  diamonddateList" :key="item.types" :class="{ 'actBgCol': dataNum === item.types }"
              @click="diamondvipBoxChange(item.typeMember, item.types, item.price)">
              <div v-if="item.types === 2" class="rightTop">立减30</div>
              <div v-else-if="item.types === 3" class="rightTop">立减61</div>

              <div class="vipDate">{{ item.date }}年VIP</div>

              <div v-if="item.types === 1" class="vipPrice">￥{{ item.price }}</div>
              <div v-else-if="item.types === 2" class="vipPrice">￥{{ item.price }}<span class="smallTxt">
                  ¥798
                </span></div>
              <div v-else-if="item.types === 3" class="vipPrice">￥{{ item.price }}<span class="smallTxt">
                  ¥1197
                </span></div>

              <div v-if="item.types === 1" class="txt">包含{{ item.points }}积分</div>
              <div v-else-if="item.types === 2" class="txt">包含{{ item.points }}积分+赠送{{ item.pointsLot }}积分</div>
              <div v-else-if="item.types === 3" class="txt">包含{{ item.points }}积分+赠送{{ item.pointsLot }}积分</div>
              <div class="gouxuan"></div>
            </li>
          </ul>
        </div>
        <div class="bottSection">
          <div class="left">
            <h1 class="methodTxt">付款方式</h1>
            <ul class="payMethods">
              <li @click="item.type !== 3 && payToggle(item.type)" v-for="item in payMethod" :key="item.type"
                :class="{ 'actBgColor': payNum === item.type }">
                <img v-if="item.type === 1" :src="item.url" alt="">
                <img v-else-if="item.type === 2" :src="item.url" alt="">
                <img class="payPalImg" v-else-if="item.type === 3" :src="item.url" alt="">
                <div v-if="item.type === 3" class="rightTop">暂未开通</div>
                <span v-if="item.name">{{ item.name }}</span>
                <div v-if="item.type !== 3 && payNum === item.type" class="gouxuan"></div>
              </li>
            </ul>
            <div class="bottomText">
              <p class="txt">*开通高等级会员优先生效，低等级会员顺延</p>
            </div>
            <div v-clickoutside="handleClickontactUs" class="code" v-if="ishidden">
              <img src="@/assets/link.png" alt="">
              <p>
                扫码联系客服
              </p>
            </div>
            <div class="contactCust">充值遇到问题？<a @click="contactCustFn">联系客服</a></div>
          </div>
          <div class="right">
            <div v-if="payNum === 1" class="qrcodePic" style="margin-top: 30px; padding-left: 25px" id="wxQrcodeImg"
              ref="wxQrcodeImg"></div>
            <div v-else-if="payNum === 2" class="qrcodePic"
              style="margin-top: 30px; padding-left: 25px; margin-bottom: 0px; width: 150px; overflow: hidden;"
              id="zxbIframe" ref="zxbIframe">
              <iframe frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" width="120" height="120"
                style="overflow: hidden;" id="zfbQrcodeImg" ref="zfbQrcodeImg" name="zxbIframe">
              </iframe>
            </div>
            <div class="price">
              <span class="totalPrice">¥{{ diamondVipPrice }}</span>
              <span class="qrcodePay">( 扫码支付 )</span>
            </div>
            <div class="delayTime">若二维码过期失效，请刷新页面重新进入支付！</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { decode } from 'js-base64';
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { memberPriQueryApi, wxQrcodeApi, queryWxPayStatus, zfbQrcodeApi, queryZfbPayStatus } from '@/api/membership.js'
import { mapGetters } from 'vuex'
export default {
  directives: { Clickoutside },
  props: {
    memberType: {
      type: Number,
      default: 2
    }
  },
  beforeDestroy () {
    clearInterval(this.wxtimer); // 清除定时器
    clearInterval(this.zfbtimer); // 清除定时器
  },
  mounted () {
    this.onceNum = this.memberType; // 会员类型1-白银/2-黄金/3-钻石
    this.memberPriQueryFn() // 会员价格查询
    if (this.onceNum === 1) { // 白银
      this.amount = 87
      this.typeMember = 2
    } else if (this.onceNum === 2) { // 黄金
      this.amount = 378
      this.typeMember = 5
    } else if (this.onceNum === 3) { // 钻石
      this.amount = 768
      this.typeMember = 8
    } else { // null 不是会员
      this.onceNum = 2;
      this.amount = 378
      this.typeMember = 5
    }

    this.wxPay() // 生成微信二维码
    this.zfbPay() // 生成支付宝二维码
  },
  watch: {
    onceNum: {
      handler (newval) {
        if (newval === 1) { // 白银
          this.amount = 87
          this.typeMember = 2
        } else if (newval === 2) { // 黄金
          this.amount = 378
          this.typeMember = 5
        } else if (newval === 3) { // 钻石
          this.amount = 768
          this.typeMember = 8
        } else {
          this.amount = 378
          this.typeMember = 5
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['GET_USER_INFO']),
    // 生成aid
    isAuthor () {
      if (!this.GET_USER_INFO.token) {
        return false
      } else {
        let arr = this.GET_USER_INFO.token.split('.')
        let userInfo = JSON.parse(decode(arr[1]))
        return userInfo.aId
      }
    },
  },
  data () {
    return {
      membershipType: [
        {
          type: 1,
          url: require('../../assets/member/silver.png'),
          name: '白银VIP'
        },
        {
          type: 2,
          url: require('../../assets/member/goldvip.png'),
          name: '黄金VIP'
        },
        {
          type: 3,
          url: require('../../assets/member/damond.png'),
          name: '钻石VIP'
        }
      ], // 会员tab类型
      goldvipPrivil: [
        {
          url: require('@/assets/member/massInteg.png'),
          name: '赠送海量积分'
        },
        {
          url: require('@/assets/member/topspeed.png'),
          name: '极速下载'
        },
        {
          url: require('@/assets/member/free.png'),
          name: '免费模型50个/天'
        },
        {
          url: require('@/assets/member/memberZone.png'),
          name: '会员模型30个/天'
        },
        {
          url: require('@/assets/member/discount.png'),
          name: '搜币模型9.5折'
        },
        {
          url: require('@/assets/member/doublePoints.png'),
          name: '登录双倍积分'
        }
      ], // 黄金vip特权
      silvervipPrivil: [
        {
          url: require('../../assets/member/massInteg.png'),
          name: '赠送海量积分'
        },
        {
          url: require('../../assets/member/topspeed.png'),
          name: '极速下载'
        },
        {
          url: require('../../assets/member/free.png'),
          name: '免费模型10个/天'
        },
        {
          url: require('../../assets/member/memberZone.png'),
          name: '会员模型5个/天'
        },
        {
          url: require('../../assets/member/discount.png'),
          name: '搜币模型9.8折'
        },
        {
          url: require('../../assets/member/doublePoints.png'),
          name: '登录双倍积分'
        }
      ],
      diamondvipPrivil: [
        {
          url: require('@/assets/member/massInteg.png'),
          name: '赠送海量积分'
        },
        {
          url: require('@/assets/member/topspeed.png'),
          name: '极速下载'
        },
        {
          url: require('@/assets/member/free.png'),
          name: '免费模型无限制'
        },
        {
          url: require('@/assets/member/memberZone.png'),
          name: '会员专区模型免费下'
        },
        {
          url: require('@/assets/member/discount.png'),
          name: '搜币模型9.5折'
        },
        {
          url: require('@/assets/member/doublePoints.png'),
          name: '登录双倍积分'
        }
      ], // 钻石vip特权
      dataNum: 2, // 黄金会员时长点击背景高亮
      onceNum: null, // VIP tab切换的标识
      payMethod: [
        {
          type: 1,
          url: require('@/assets/wechat.png'),
          name: '微信支付'
        },
        {
          type: 2,
          url: require('@/assets/alipay_icon.png'),
          name: '支付宝'
        },
        {
          type: 3,
          url: require('@/assets/member/Paypal2.png'),
        },
      ], // 支付方式
      golddateList: [], // 黄金年限数据
      silverdateList: [], // 白银年限数据
      diamonddateList: [], // 钻石年限数据
      payNum: 1, // 支付方式点击背景高亮
      goldVipPrice: 378, // 黄金会员价格总和
      sliverVipPrice: 87, // 白银会员价格总和
      diamondVipPrice: 768, // 钻石会员价格总和
      silverPrice: 29, // 白银会员价格
      silverPoints: 600, // 白银会员积分
      silverDate: 1, // 白银会员时长
      ishidden: false, //联系客服
      typeMember: null, // 会员type,
      amount: null

    }
  },
  methods: {
    /**
     * @tab切换
     */
    tabChange (type) {

      if (type === 1) { // 白银
        this.amount = 87
        this.typeMember = 2
        this.payNum = 1
      } else if (type === 2) { // 黄金
        this.amount = 378
        this.typeMember = 5
        this.payNum = 1
      } else if (type === 3) { // 钻石
        this.amount = 768
        this.typeMember = 8
        this.payNum = 1
      }
      this.dataNum = 2;
      this.payNum = 1;
      this.onceNum = type;
      this.sliverVipPrice = 87;
      this.goldVipPrice = 378;
      this.silverPrice = 29;
      this.diamondVipPrice = 768;
      this.silverPoints = 600;
      this.silverDate = 1;
      this.wxPay()
      this.zfbPay()
    },
    /**
     * @黄金会员 点击会员时长
     */
    goldvipBoxChange (typeMember, n, price) {
      this.amount = price
      this.typeMember = typeMember
      this.goldVipPrice = price;
      this.dataNum = n;
      this.wxPay()
      this.zfbPay()
    },
    /**
     * @白银会员 点击会员时长
     */
    silvervipBoxChange (typeMember, n, price) {
      this.typeMember = typeMember
      this.sliverVipPrice = price;
      this.dataNum = n;
      if (n === 1) {
        this.amount = this.silverPrice
      } else {
        this.amount = price
      }
      this.wxPay()
      this.zfbPay()
    },
    /**
     * @钻石会员 点击会员时长
     */
    diamondvipBoxChange (typeMember, n, price) {
      this.amount = price
      this.typeMember = typeMember
      this.diamondVipPrice = price;
      this.dataNum = n;
      this.wxPay()
      this.zfbPay()
    },
    /**
     * @支付方式切换
     */
    payToggle (type) {
      this.payNum = type;
      if (type === 1) { // 微信
        let zxbIframeDiv = document.getElementById("zxbIframe");
        zxbIframeDiv.innerHTML = "";
        this.wxPay()
      } else if (type === 2) {
        this.zfbPay()
      }

    },
    /**
     * @白银月数加减
     */
    sub () {
      this.silverPoints = 600;
      if (this.silverDate === 1) {
        return
      }
      this.silverDate--;
      this.silverPrice = 29 * this.silverDate;
      this.silverPoints = 600 * this.silverDate;

    },
    add (item) {
      if (this.silverDate === 36) {
        return fasle
      }
      this.silverDate++;
      this.silverDate = this.silverDate;
      this.silverPrice = 29 * this.silverDate;
      this.silverPoints = 600 * this.silverDate;
    },
    /**
     * @desc 去积分充值页面
     */
    goPointRecharge () {
      this.$emit('changeIsHidden', true)
    },
    /**
     * @desc 联系客服
     */
    contactCustFn () {
      this.ishidden = true
    },
    handleClickontactUs () {
      this.ishidden = false
    },
    /**
     * @desc 会员价格查询
     */
    async memberPriQueryFn () {
      const res = await memberPriQueryApi()
      if (res.code === 200) {
        this.silverdateList = res.data[0].silverDTOList
        this.golddateList = res.data[0].goldDTOList
        this.diamonddateList = res.data[0].diamondDTOList
      }
    },

    qrcode (url, name) {
      // 前端根据 URL 生成支付二维码
      return new QRCode(name, {
        width: 120,
        height: 120,
        text: url,
        colorDark: "#000",
        colorLight: "#fff",
      });
    },
    handleQueryWxPayStatus (sn) {
      let that = this;
      // 查询微信支付状态
      queryWxPayStatus({ outTradeNo: sn }).then((res) => {

        if (res.data.trade_state == "SUCCESS") {
          // 当查询到支付成功时
          this.$emit('memberHidden', false)
          this.$emit('isBuySuccess', true)
          this.$emit('changeMemType', this.onceNum)
          clearInterval(that.wxtimer); // 清除定时器
        }
      });
    },

    /**
     * @desc 生成微信二维码
     */
    async wxPay () {
      clearInterval(this.wxtimer); // 清除定时器
      const params = {
        amount: this.amount,
        aid: this.isAuthor,
        type: this.typeMember
      };

      await wxQrcodeApi(params).then((res) => {
        this.$refs.wxQrcodeImg.innerText = "";
        // 根据这个值生成相对应的支付二维码
        this.qrcode(res.data.codeUrl, "wxQrcodeImg");
        if (res.data.outTradeNo) {
          this.wxtimer = setInterval(() => {
            // 通过定时器每间隔一会去请求查询支付状态
            this.handleQueryWxPayStatus(res.data.outTradeNo);
          }, 1000);
        }
      });
    },

    handleQueryZfbPayStatus (sn) {
      let that = this;
      // 查询支付宝支付状态
      queryZfbPayStatus({ outTradeNo: sn }).then(res => {
        if (res.data.trade_state == "SUCCESS") {
          // 当查询到支付成功时
          this.$emit('memberHidden', false)
          this.$emit('isBuySuccess', true)
          this.$emit('changeMemType', this.onceNum)
          clearInterval(that.zfbtimer); // 清除定时器
        }
      });
    },

    /**
     * @desc 生成支付宝二维码
    */
    async zfbPay () {
      clearInterval(this.zfbtimer); // 清除定时器
      const params = {
        amount: this.amount,
        aid: this.isAuthor,
        type: this.typeMember
      };

      await zfbQrcodeApi(params).then(res => {
        let zxbIframeDiv = document.getElementById("zxbIframe");
        zxbIframeDiv.innerHTML = "";
        zxbIframeDiv.innerHTML =
          '<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" width="300" height="120" style="overflow: hidden;" id="zfbQrcodeImg" ref="zfbQrcodeImg" name="zxbIframe"></iframe>';
        let zxbIframe = document["zxbIframe"]
          ? document["zxbIframe"]
          : window.frames["zxbIframe"];
        zxbIframe.document.write(res.data.body);
        if (res.data.outTradeNo) {
          this.zfbtimer = setInterval(() => {
            // 通过定时器每间隔一会去请求查询支付状态
            this.handleQueryZfbPayStatus(res.data.outTradeNo);
          }, 1000);
        }
      });
    },
    cancel () {
      this.$emit('memberHidden', false)
    }

  }

}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}

.membershipWrap {
  width: 1000px;
  height: 430px;
  border-radius: 15px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 9999;

  .membershipTab {
    width: 100%;
    height: 80px;
    color: #fff;
    display: flex;
    flex-direction: row;
    user-select: none;

    .membershipType {
      cursor: pointer;
      border-radius: 10px 10px 0 0;
      flex: 1;
      height: 80px;
      text-align: center;
      background: linear-gradient(to right, #a6a6a6, rgb(166, 166, 166));

      img {
        vertical-align: middle;
        margin-right: 20px;
        margin-top: 5px;
        -webkit-user-drag: none;
      }

      span {
        vertical-align: middle;
        font-size: 28px;
        font-weight: 600;
      }
    }

    .goldColor {
      background: linear-gradient(to right, #ba8b5f, rgb(186, 139, 95));
    }

    .damondColor {
      background: linear-gradient(to right, #53608c, rgb(83, 96, 140));
    }

    .height {
      height: 100px;
      margin-top: -20px;
      text-align: center;
      line-height: 100px;
    }
  }

  .membershipCont {
    width: 99.9%;
    height: 400px;
    //background-color: #e5e5e5;
    border: 1px solid #e0b58c;
    border-radius: 0 0 15px 15px;
    display: flex;
    flex-direction: row;
    user-select: none;

    .leftCont {
      width: 239.48px;
      height: 370px;
      background-color: #fff;
      border-radius: 12px;
      margin: 15px 0 0 15px;

      h1 {
        text-align: center;
        font-size: 26px;
        line-height: 70px;
        font-weight: 900;
        text-shadow: 1px 1px 2px #888888;
      }

      .privClassif {
        width: 239.48px;
        display: flex;
        flex-direction: column;

        li {
          display: flex;
          flex-direction: row;
          justify-content: start;
          align-items: center;
          padding-left: 10px;
          box-sizing: border-box;
          margin-bottom: 6px;

          span {
            display: inline-block;
            width: 150px;
            height: 20px;
            line-height: 10px;
            border-bottom: 2px solid #ccc;
            margin-left: 20px;
            font-size: 14px;
            font-weight: 500;
          }
        }
      }
    }

    .rightCont {
      width: 700px;
      height: 365px;
      margin-top: 18px;
      margin-left: 20px;

      .topSection {
        width: 100%;
        height: 120px;

        ul {
          width: 100%;
          height: 120px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          li {
            width: 214px;
            height: 100%;
            background-color: #fff;
            border-radius: 13px;
            text-align: center;
            position: relative;
            cursor: pointer;

            .vipDate {
              width: 180px;
              height: 30%;
              border-bottom: 2px solid #ccc;
              font-size: 28px;
              font-weight: 500;
              text-align: center;
              margin-top: 18px;
              margin-left: 15px;
            }

            .vipPrice {
              color: #ff4f00;
              font-size: 24px;
              font-weight: 500;
              margin-top: 8px;

              span {
                color: #ccc;
                font-size: 20px;
              }

              .smallTxt {
                font-size: 14px;
                text-decoration: line-through;
              }
            }

            .txt {
              font-size: 12px;
              font-weight: 500;
              margin-top: 10px;
            }

            .rightTop {
              width: 60px;
              height: 20px;
              background-color: #e0b58c;
              position: absolute;
              right: 0;
              font-size: 12px;
              border-radius: 0 10px 0 10px;
              text-align: center;
              line-height: 20px;
            }
          }
        }

        .actBgCol {
          border: 1px solid #e0b58c;
          background-color: #fef1e3;

          .gouxuan {
            width: 60px;
            height: 60px;
            position: absolute;
            right: 0px;
            bottom: 0px;
            background-image: url("../../assets/member/gouxuan.png");
            background-repeat: no-repeat;
            background-size: 60% 60%;
            background-position: 100% 100%;
          }

          .actSub {
            color: #ccc;
          }
        }
      }

      .bottSection {
        width: 100%;
        height: 230px;
        background-color: #fff;
        border-radius: 13px;
        margin-top: 17px;
        display: flex;
        flex-direction: row;
        font-size: 12px;

        .left {
          padding-top: 25px;
          box-sizing: border-box;

          .methodTxt {
            font-size: 26px;
            font-weight: 500;
            margin-left: 30px;
          }

          .payMethods {
            display: flex;
            flex-direction: row;
            margin-left: 20px;
            margin-top: 10px;
            user-select: none;


            li {
              width: 150px;
              height: 42px;
              border: 2px solid #e0b58c;
              border-radius: 10px;
              margin-right: 8px;
              line-height: 42px;
              position: relative;
              cursor: pointer;


              img {
                width: 20%;
                margin-left: 12px;
                margin-top: 5px;
                margin-right: 10px;
                -webkit-user-drag: none;
              }

              .payPalImg {
                width: 70%;
                margin-top: 9px;
                margin-left: 14px;
              }

              .rightTop {
                width: 58px;
                height: 17px;
                background-color: #e0b58c;
                position: absolute;
                right: -6px;
                bottom: 27px;
                font-size: 12px;
                scale: 0.8;
                border-radius: 0 10px 0 10px;
                text-align: center;
                line-height: 17px;
              }

              span {
                display: inline-block;
                transform: translateY(-7px);
                font-size: 20px;
              }

              .gouxuan {
                width: 50px;
                height: 50px;
                position: absolute;
                right: -1px;
                bottom: -1px;
                background-image: url("../../assets/member/gouxuan.png");
                background-repeat: no-repeat;
                background-size: 50% 50%;
                background-position: 100% 100%;
              }
            }

            .actBgColor {
              background-color: #fef1e3;
            }
          }

          .bottomText {
            display: flex;
            flex-direction: row;
            position: relative;

            .txt {
              position: absolute;
              top: 18px;
              left: 19px;
              font-size: 14px;
              color: #999;
              font-weight: 500;
            }

            .text1 {
              font-size: 18px;
              font-weight: 500;
              color: #999;
              margin: 50px 0 0 170px;
            }

            .text2 {
              width: 140px;
              height: 40px;
              background: linear-gradient(to bottom,
                  #ebb97d,
                  rgba(235, 185, 125, 0.5));
              border-radius: 50px;
              text-align: center;
              line-height: 40px;
              font-size: 22px;
              font-weight: 800;
              margin-top: 27px;
              margin-left: 10px;
              box-shadow: 4px 4px 4px #999;
            }
          }

          .code {
            position: absolute;
            top: 300px;
            left: 380px;
            background-color: rgba(0, 0, 0, .5);
            padding: 5px;
            border-radius: 10px;
            margin-right: 10px;

            &:last-child {
              margin-right: 0;
            }

            img {
              display: block;
              width: 70px;
              margin: 0 auto;
              padding-top: 6px;
            }

            p {
              font-size: 14px;
              color: #fff;
              padding: 6px 7px;
              text-align: center;
              white-space: nowrap;
            }
          }

          .contactCust {
            font-size: 14px;
            color: #999;
            font-weight: 500;
            margin-top: 94px;
            margin-left: 31px;

            a {
              color: #e67030;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }

        .right {
          position: relative;


          .price {
            margin-top: 8px;
            margin-left: 20px;

            .totalPrice {
              color: #ff4f00;
              font-size: 26px;
              font-weight: 500;
            }

            .qrcodePay {
              font-size: 14px;
              font-weight: 500;
              margin-left: 5px;
            }
          }

          .delayTime {
            position: absolute;
            text-wrap: nowrap;
            left: -100px;
            bottom: 14px;
            font-size: 14px;
            color: #999;
            font-weight: 500;
          }
        }
      }
    }
  }

  .membershipActBgCol_2 {
    background: linear-gradient(to right, #ba8b5f, #ba8b5f);
  }

  .membershipActBgCol_1 {
    background: linear-gradient(to right, #a6a6a6, #a6a6a6);
  }

  .membershipActBgCol_3 {
    background: linear-gradient(to right, #53608c, #53608c);
  }

  .cancel {
    width: 35px;
    height: 35px;
    background-color: rgba(0, 0, 0, .8);
    color: #fff;
    font-size: 24px;
    text-align: center;
    line-height: 32px;
    border-radius: 50%;
    position: absolute;
    top: -20px;
    right: -34px;
    z-index: 1000;
    cursor: pointer;
  }
}
</style>